// @flow
import { defineMessages } from 'react-intl';

/*eslint max-len:0*/
export const generic = defineMessages({
    UNEXPECTED_ERROR: {
        id: 'feedback.generic.try-again',
        defaultMessage: 'Oops! An unexpected error has occurred. Please refresh to continue or try again later.'
    },
    SAVE_FAILED: {
        id: 'feedback.generic.save-failed',
        defaultMessage: 'Oops! An unexpected error has occurred. Changes were not saved, please try again.'
    },
    NOTHING_TO_SAVE: {
        id: 'feedback.generic.nothing-to-save',
        defaultMessage: 'Nothing to save!'
    },
    UPDATE_SUCCESSFUL: {
        id: 'feedback.generic.update-successful',
        defaultMessage: 'Changes successfully updated.'
    }
});

export const forgottenPasswordMessages = {
    FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT: 'A password reminder email has been sent'
};



// WEBPACK FOOTER //
// ./src/core/constants/feedback.js